var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "brb-image-preview",
      },
      [
        _c("img", {
          staticClass: "image",
          attrs: { src: _vm.currentImageSrc, draggable: "false" },
        }),
        _c("div", { staticClass: "action-layer" }, [
          _c(
            "div",
            {
              staticClass: "action-close",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_c("font-awesome-icon", { attrs: { icon: "xmark" } })],
            1
          ),
          _vm.hasPrevImage
            ? _c(
                "div",
                {
                  staticClass: "action-prev",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.prevImage.apply(null, arguments)
                    },
                  },
                },
                [_c("font-awesome-icon", { attrs: { icon: "angle-left" } })],
                1
              )
            : _vm._e(),
          _vm.hasNextImage
            ? _c(
                "div",
                {
                  staticClass: "action-next",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.nextImage.apply(null, arguments)
                    },
                  },
                },
                [_c("font-awesome-icon", { attrs: { icon: "angle-right" } })],
                1
              )
            : _vm._e(),
          _vm.core.images.length > 1
            ? _c("div", { staticClass: "indicator" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.currentIndex + 1) +
                    "/" +
                    _vm._s(_vm.core.images.length) +
                    " "
                ),
              ])
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }